const Unlock = () => {
  return (
    <svg
      width="28px"
      height="28px"
      viewBox="0 0 28 28"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>ic_fluent_unlock_28_regular</title>
      <desc>Created with Sketch.</desc>
      <g
        id="🔍-Product-Icons"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="ic_fluent_unlock_28_regular" fill="#212121" fillRule="nonzero">
          <path
            d="M13.2881643,2.00489799 L13.5,2 C15.8751084,2 17.8371399,3.84564416 17.9904262,6.20451395 C18.0172864,6.6178557 17.7039812,6.97470986 17.2906394,7.00157003 C16.8772977,7.02843019 16.5204435,6.71512495 16.4935833,6.3017832 C16.3914884,4.73067987 15.0832012,3.5 13.5,3.5 C11.9023191,3.5 10.5963391,4.74891996 10.5050927,6.32372721 L10.5,6.5 L10.4994005,9.499 L19.7504315,9.5 C20.9930721,9.5 22.0004315,10.5073593 22.0004315,11.75 L22.0004315,23.7518352 C22.0004315,24.9944759 20.9930721,26.0018352 19.7504315,26.0018352 L7.24840055,26.0018352 C6.00575986,26.0018352 4.99840055,24.9944759 4.99840055,23.7518352 L4.99840055,11.75 C4.99840055,10.5073593 6.00575986,9.5 7.24840055,9.5 L8.99940055,9.499 L9,6.5 C9,4.08572667 10.9012365,2.11551091 13.2881643,2.00489799 L13.5,2 L13.2881643,2.00489799 Z M19.7504315,11 L7.24840055,11 C6.83418699,11 6.49840055,11.3357864 6.49840055,11.75 L6.49840055,23.7518352 C6.49840055,24.1660488 6.83418699,24.5018352 7.24840055,24.5018352 L19.7504315,24.5018352 C20.164645,24.5018352 20.5004315,24.1660488 20.5004315,23.7518352 L20.5004315,11.75 C20.5004315,11.3357864 20.164645,11 19.7504315,11 Z M13.5,16.25 C14.3284271,16.25 15,16.9215729 15,17.75 C15,18.5784271 14.3284271,19.25 13.5,19.25 C12.6715729,19.25 12,18.5784271 12,17.75 C12,16.9215729 12.6715729,16.25 13.5,16.25 Z"
            id="🎨-Color"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export default Unlock;
